import React from 'react'

const YouTubeIssues = () => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">YouTube known issues</h3>
      
      <div className="flex items-start gap-3">
        <div className="w-5 h-5 text-red-500 mt-0.5 flex-shrink-0">
          <svg fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
        </div>
        <div>
          <p className="text-sm text-gray-900">
            Issues with viewing some features on YT Shorts
          </p>
        </div>
      </div>
    </div>
  )
}

export default YouTubeIssues
